module.exports = {
  "ubx-0001": {
    "identifierType": "OTHER",
    "maxAge": 86400000,
    "parameters": {
      "group": [
        "control",
        "variation",
        "variation_b"
      ]
    }
  }
};